import { Flex } from "@chakra-ui/react";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { MapIcon } from "@nens/ranalib";

import { getList } from "./../state/layerRasterSourcesMenu";
import CollapsableSidebarStyles from "./CollapsableSidebar.module.css";
import LayerMenuBaseLayersSubmenu from "./LayerMenuBaseLayersSubmenu";
import LayerMenuCalculationSubmenu from "./LayerMenuCalculationSubmenu";
import LayerMenuModelRastersSubmenu from "./LayerMenuModelRastersSubmenu";
import LayerMenuOneDElementsSubmenu from "./LayerMenuOneDElementsSubmenu";
import LeftMenuHeader from "./LeftMenuHeader";

const LayerMenu = () => {
  const sourceRasters = useSelector(getList);
  const demRaster = sourceRasters.find((raster) => raster.type === "dem_file");

  return (
    <div className={`${CollapsableSidebarStyles.LeftMenu}`}>
      <LeftMenuHeader Icon={MapIcon}>
        <FormattedMessage id="layerMenu.header" defaultMessage="Map layers" />
      </LeftMenuHeader>

      <Flex flexDir="column">
        <LayerMenuBaseLayersSubmenu />
        <LayerMenuCalculationSubmenu />
        {demRaster && <LayerMenuModelRastersSubmenu demRaster={demRaster} />}
        <LayerMenuOneDElementsSubmenu />
      </Flex>
    </div>
  );
};
export default LayerMenu;
